
import React, { Component } from 'react'
import {base} from 'settings/global'
import classnames from 'classnames'

class HomeBanner extends Component {
  _sortedList(list){
    var sortedList = list.sort(function(prev,next){
      return prev.listorder - next.listorder
    })
    return sortedList
  }
  componentDidMount() {
    var self = this
    var initBanner = function(resp){
      var wrapper = $('.imgCon')
      var swiperList = $('.imgCon li')
      var contentList = (resp && resp.body)?resp.body.Content:resp
      contentList = self._sortedList(contentList)
      var sliderElement
      var appendArea = []
      if(contentList.length>swiperList.length){ //如果接口返回的数据长度比现有banner长度大
        for(var i = 0;i<= contentList.length-swiperList.length-1;i++){
          appendArea.push(wrapper.html())
        }
        $('.imgCon').append(appendArea)//把for循环得到的数据append到banner容器中
      }
      for(var i = 0;i<= contentList.length - 1;i++){
        (function(index){
          sliderElement = $('.imgCon li').eq(index) //banner index
          // sliderElement.find('a').attr('href',contentList[index].LinkUrl || 'javascript:;'); //banner跳转地址
          sliderElement.find('a').attr('href',contentList[index].url || 'javascript:;') //banner跳转地址
          // sliderElement.css('background-image','url('+ contentList[index].ImgUrl + ')')
          sliderElement.css('background-image','url('+ contentList[index].thumb + ')')
          // .attr('title',contentList[index].OperationTitle) //banner图片地址和title显示
          .attr('title',contentList[index].title) //banner图片地址和title显示
          // .addClass(contentList[index].Extention1);//添加扩展字段1 为className
        })(i)
      }
      //焦点图
      function showSilder(silderId) {
        var silderCon = $(silderId)
        var oimgCon = silderCon.find('ul').eq(0)

        var imgArr = oimgCon.find('li')

        var osilderDot = silderCon.find('.silderDots')
        var osilderPrev = silderCon.find('.silderPage .prev');
        var osilderNext = silderCon.find('.silderPage .next');

        var str1 = ''
        var num = 0
        var time = null
        for (var i = 0; i < imgArr.length; i++) {
          str1 += '<li>' + (i + 1) + '</li>'
        }
        osilderDot.html(str1)
        // 加事件
        var asilderLi = osilderDot.find('li')
        var asilderImg = oimgCon.find('li')
        asilderImg.hide()
        asilderImg.eq(0).show()
        asilderLi.eq(0).addClass('cur')
        function showImg() {
          asilderImg.fadeOut()
          asilderImg.eq(num).fadeIn()
          asilderLi.removeClass('cur')
          asilderLi.eq(num).addClass('cur')
        }
        asilderLi.click(function() {
          num = $(this).index()
          showImg()
        })
        function silderTime() {
          time = setInterval(function() {
            num++
            if (num > imgArr.length - 1) {
              num = 0
            }
            showImg()
          }, 7000)
        }
        silderTime()

        osilderPrev.click(function () {
          num = $(this).index()
          showImg()
        })
        osilderNext.click(function () {
          num = $(this).index() - 1
          showImg()
        })

        silderCon.hover(function() {
          clearInterval(time)
        }, function() {
          silderTime()
        })
      }

      //滚动焦点图
      function autopic_control(maincon, speed1, speed2, up, down) {
        $(maincon).children('ul').html(
          $(maincon).children('ul').html() + $(maincon).children('ul').html()
          + $(maincon).children('ul').html())
        $(maincon).children('ul').width(
            $(maincon).children('ul').children('li:first').width()
            * $(maincon).children('ul').children('li').length)
        var x = $(maincon).children('ul').width() / 3
        var y = $(maincon).children('ul').children('li').length / 3
        var t
        $(maincon).scrollLeft(x)
        function init1() {
          y--
          if (y < 0) {
            y = $(maincon).children('ul').children('li').length / 3 - 1
          }

          function mycase() {
            var self = arguments.callee
            t = setTimeout(function() {
              $(maincon).scrollLeft(x)
              if (x < 0) {
                x = $(maincon).children('ul').width() / 3
              }

              if (x >= $(maincon).children('ul').children('li:first').width()
                  * y + 45) {
                x -= speed2
              }

              if (x < $(maincon).children('ul').children('li:first').width()
                  * y + 45) {
                x--
              }

              self()
              if (x < $(maincon).children('ul').children('li:first').width()
                  * y) {
                clearTimeout(t)
              }

            }, speed1)
          }

          mycase()
        }

        function init2() {
          y++
          if (y > $(maincon).children('ul').children('li').length * 2 / 3) {
            y = $(maincon).children('ul').children('li').length / 3 + 1
          }

          function mycase() {
            var self = arguments.callee
            t = setTimeout(function() {
              $(maincon).scrollLeft(x)
              if (x > $(maincon).children('ul').width() * 2 / 3) {
                x = $(maincon).children('ul').width() / 3
              }

              if (x <= $(maincon).children('ul').children('li:first').width()
                  * y - 45) {
                x += speed2
              }

              if (x > $(maincon).children('ul').children('li:first').width()
                  * y - 45) {
                x++
              }

              self()
              if (x > $(maincon).children('ul').children('li:first').width()
                  * y) {
                clearTimeout(t)
              }

            }, speed1)
          }

          mycase()
        }

        $(up).click(function() {
          init1()
        })
        $(down).click(function() {
          init2()
        })
      }

      $(function(){
        showSilder('#silderCon')
        showSilder('#userStory')
        autopic_control('.main',15,35,'.u_control','.d_control')
      })
    }
    this.props.banner &&  initBanner(this.props.banner)
  }
  render() {
    return (
      <div>
        <ul className="imgCon">
          <li><a className="silder-link" target="_blank"></a></li>
        </ul>
        <ul className="silderDots clearfix">
          <li>1</li>
        </ul>
        <div className="silderPage">
          <ul>
            <li className="prev">
              <img src={require('./images/left.png')}/>
            </li>
            <li>
              <p><a href="./aboutUs/company"><img src={require('./images/about_home_icon.png')}/> </a></p>
            </li>
            <li className="next">
              <img src={require('./images/right.png')}/>
            </li>
          </ul>
        </div>

      </div>
    )
  }
      }
export { HomeBanner }



// WEBPACK FOOTER //
// ./modules/home/HomeBanner.js